import "./utils/dayjs"

import React from "react"
import { createRoot } from "react-dom/client"
import { LanguageProvider, ThemeProvider } from "@george-labs.com/design-system"
import { hu } from "date-fns/locale"
import "./index.css"
import App from "./App"
import "@george-labs.com/design-system/dist/gds-main.min.css"
import "@george-labs.com/design-system/dist/gds-store.min.css"
import "@george-labs.com/design-system/dist/gds-components.min.css"
import { compose } from "redux"
import { GlobalProvider } from "./providers/GlobalProvider"
import "./i18n"
import axios from "axios"
import { saveDeeplink } from "./utils/deeplink"

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

axios.defaults.baseURL = import.meta.env.DEV ? "" : import.meta.env.BASE_URL

// Version information
console.group("Verzió információk: ")
console.log(
  `%c Verzió: ${import.meta.env.VITE_CLIENT_VERSION}`,
  "background: #222; color: #bada55",
)
console.log(
  `%c Git Branch: ${import.meta.env.VITE_CLIENT_GIT_BRANCH}`,
  "background: #222; color: #bada55",
)
console.log(
  `%c Git Hash: ${import.meta.env.VITE_CLIENT_GIT_HASH}`,
  "background: #222; color: #bada55",
)
console.log(
  `%c Git Date: ${import.meta.env.VITE_CLIENT_GIT_DATE}`,
  "background: #222; color: #bada55",
)
console.groupEnd()

const container = document.getElementById("root")
const root = createRoot(container)

saveDeeplink()

root.render(
  <React.StrictMode>
    <ThemeProvider theme={ThemeProvider.THEME.BS4}>
      <GlobalProvider>
        <LanguageProvider locale={hu} strings={{}}>
          <App />
        </LanguageProvider>
      </GlobalProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
